module.exports = __webpack_public_path__ + "@/assets/img/file-plus.adaf80ab.svg";